import React from 'react';
import { motion } from 'framer-motion';
const pains = [{
  tag: '',
  icon: '😔',
  text: 'Haces afirmaciones todos los días, pero al final del mes tu cuenta bancaria sigue exactamente igual.'
}, {
  tag: '',
  icon: '🔒',
  text: 'Sientes un "techo invisible" que te impide avanzar sin importar cuánto te esfuerces ni cuánto positiva seas.'
}, {
  tag: '',
  icon: '😰',
  text: 'En el fondo, tienes miedo de que el éxito sea para "otras" y no para ti. Que hagas lo que hagas, tu vibración siempre esté "baja".'
}];
export function PainSection() {
  return <section className="py-20 bg-primary relative overflow-hidden" id="dolor" data-id="element-169" data-mp="2baoft7vcp9bl">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-[600px] h-[1px] bg-gradient-to-r from-transparent via-rose to-transparent" data-id="element-170" data-mp="2g9988l4d2oph" />
      <div className="absolute -bottom-[200px] -right-[200px] w-[500px] h-[500px] rounded-full bg-[radial-gradient(ellipse,rgba(232,121,160,0.04)_0%,transparent_70%)] pointer-events-none" data-id="element-171" data-mp="22a026e9vdaz8" />
      
      <div className="max-w-[1100px] mx-auto px-5 relative z-10" data-id="element-172" data-mp="3rlptdtxwm2ka">
        
        {/* Intro */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-[760px] mx-auto mb-16" data-id="element-173" data-mp="3nknp2yp4r0bg">
          <div className="inline-flex items-center gap-2.5 text-[13px] font-semibold tracking-[0.15em] uppercase text-rose mb-5" data-id="element-174" data-mp="hivgdiyxws6">
            <span className="w-10 h-[1px] bg-rose/40" data-id="element-175" data-mp="33xgc95bmy2zh" />
            Esto es para ti, mi niña
            <span className="w-10 h-[1px] bg-rose/40" data-id="element-176" data-mp="3imceglr0gls6" />
          </div>
          <h2 className="font-display text-[26px] md:text-[42px] font-bold leading-[1.25] text-white mb-5" data-id="element-177" data-mp="3innhukgjnrir">
            Sé exactamente cómo te sientes...<br data-id="element-178" data-mp="2q5rzcztkbahg" />
            <span className="text-gradient-rose" data-id="element-179" data-mp="2q59s785d3bur">y no, no estás sola en esto.</span>
          </h2>
          <p className="text-base text-gray-400 leading-[1.8]" data-id="element-180" data-mp="2l7qeqaghn33v">
            Lo que estás a punto de leer no es marketing. Es la realidad de miles de mujeres en LATAM que, como tú, han intentado de todo y sienten que algo falla.
          </p>
        </motion.div>

        {/* Carta narrativa emocional */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="max-w-[820px] mx-auto mb-16 bg-card border border-rose/20 rounded-[32px] p-7 md:p-12 relative" data-id="element-181" data-mp="yuogav0i20s6">
          <div className="absolute top-0 left-0 right-0 h-[3px] rounded-t-[32px] bg-gradient-to-r from-rose to-transparent" data-id="element-182" data-mp="b4u4mgrx2i9i" />
          
          <span className="font-script text-2xl text-rose mb-6 block" data-id="element-183" data-mp="f7qpke4xiqgm">
            Para ti, que llevas tanto tiempo esperando...
          </span>
          
          <div className="text-[17px] text-gray-400 leading-[1.9] space-y-5" data-id="element-184" data-mp="1qjrnaijrtp8i">
            <p data-id="element-185" data-mp="1vjcufg93h3wb">
              Te levantas cada mañana con esa <strong className="text-white font-semibold" data-id="element-186" data-mp="1vi1j8vdbktv6">sensación familiar en el pecho</strong>. Esa mezcla de esperanza y miedo. Repites tus afirmaciones frente al espejo, haces tu lista de gratitud, visualizas la vida que quieres... y luego miras tu cuenta bancaria y el número no cambió.
            </p>
            <p data-id="element-187" data-mp="1vvwy5unnkucw">
              Has leído los libros. Has visto los videos. Quizás incluso has pagado cursos. Y sientes que <em className="text-rose-light not-italic font-medium" data-id="element-188" data-mp="1rulhiemrbjgu">todas las demás lo están logrando menos tú</em>. Que hay algo roto dentro de ti. Que quizás simplemente no eres de las que "reciben".
            </p>
            
            <span className="block my-7 p-5 bg-rose/5 border-l-4 border-rose rounded-r-lg text-lg font-semibold text-white italic leading-relaxed" data-id="element-189" data-mp="1cym2ek18cj27">
              "¿Por qué a mí no me funciona si hago exactamente lo mismo que las demás?"
            </span>
            
            <p data-id="element-190" data-mp="37au2ebserq4u">
              Y lo peor no es el dinero. Lo peor es esa <strong className="text-white font-semibold" data-id="element-191" data-mp="33cwct7uq720x">voz interna</strong> que a las 2 de la madrugada te susurra: <em className="text-rose-light not-italic font-medium" data-id="element-192" data-mp="3afb0eo043ok2">"¿Y si el éxito simplemente no es para personas como yo?"</em> Esa duda que cargas en silencio porque afuera tienes que parecer fuerte, positiva, que "lo estás trabajando".
            </p>
            <p data-id="element-193" data-mp="35feycuaz6775">
              Llevas meses —quizás años— postergando tu vida real esperando que la manifestación "active". Esperando la llamada, el cliente, la oportunidad. Mientras por dentro sientes que el tiempo pasa y tú sigues igual. <strong className="text-white font-semibold" data-id="element-194" data-mp="2wg1tkexsq6sr">Eso no es falta de fe. Eso es falta del método correcto.</strong>
            </p>
          </div>
        </motion.div>

        {/* 3 cards de dolor específico */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-[900px] mx-auto mb-12" data-id="element-195" data-mp="2mpqd5swxe54z">
          {pains.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.15
        }} className="bg-card border border-danger/10 rounded-2xl p-7 relative overflow-hidden hover:-translate-y-1 hover:border-danger/30 transition-all" data-id="element-196" data-mp="28rs5t7h0v8yz" data-mpi={i}>
              <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-danger to-transparent" data-id="element-197" data-mp="1z1tk1mb3rfau" />
              <div className="absolute top-3.5 right-3.5 bg-danger/10 text-danger text-[10px] font-bold tracking-widest uppercase px-2 py-1 rounded-full border border-danger/20" data-id="element-198" data-mp="2d1beoib2xms4">
                {pain.tag}
              </div>
              <span className="text-3xl mb-3.5 block" data-id="element-199" data-mp="2mqcr5yif1m1c">{pain.icon}</span>
              <p className="text-[15px] font-medium text-white leading-relaxed" data-id="element-200" data-mp="2hsjq1jvyzi7x">
                {pain.text}
              </p>
            </motion.div>)}
        </div>

        {/* Remate */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-[720px] mx-auto p-8 md:p-10 bg-gradient-to-br from-rose/5 to-violet/5 border border-rose/20 rounded-3xl" data-id="element-201" data-mp="2qt9gs96diies">
          <p className="text-[19px] font-semibold leading-[1.7] text-white" data-id="element-202" data-mp="1xgi3igj8x2im">
            El problema <span className="text-gold" data-id="element-203" data-mp="226ykubq6t8a9">no eres tú</span>, mi niña. El problema es que nadie te enseñó a combinar la <span className="text-gold" data-id="element-204" data-mp="276bepgfh7fmc">intención</span> con la <span className="text-gold" data-id="element-205" data-mp="275jhy2a57buh">frecuencia</span> y la <span className="text-gold" data-id="element-206" data-mp="2c4w5kp8u8my4">acción alineada</span>. Eso es exactamente lo que el sistema de la Abu hace en 30 días.
          </p>
        </motion.div>

      </div>
    </section>;
}